module.exports = __webpack_public_path__ + "img/product-hunt-logo.3a34aeef.svg";